module.exports = __webpack_public_path__ + "static/media/button-wizard-5.67b04d7c.png";